import React from 'react';
import { LIST_ICON_WEB_SAMPLE } from '@src/constants/upload';
import { StyledSourcesRow, StyledSourceIcon } from './index.style';

/**
 * Suggested news sources row — 32×32 rounded icons centered below the URL field.
 *
 * @param {Array<{ icon, alt }>} [sources] — override list; defaults to `LIST_ICON_WEB_SAMPLE`.
 */
const UrlSuggestedSources = ({ sources = LIST_ICON_WEB_SAMPLE }) => (
  <StyledSourcesRow>
    {sources.map((s) => (
      <StyledSourceIcon key={s.alt} src={s.icon} alt={s.alt} />
    ))}
  </StyledSourcesRow>
);

export default UrlSuggestedSources;
